import { PrimaryButton } from "@fluentui/react";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import AddButton from "../../components/AddButton";
import { AdminUserListColumn } from "../../constants/Columns";
import userContext from "../../context/users/UserContext";
import {
  changeUserStatus,
  getAdminUserList,
  getSignatureImage,
  fetchEditUserData,
  changeUserLockStatus,
} from "../../service/UserService";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DataTable from "../../components/DataTable/DataTable";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import NotAuthorized from "../../components/NotAuthorized";
import { FirmAdminUserColumns } from "../../constants/Columns/FirmAdminUser";
import PageHeader from "../../components/PageHeader";
import ListView from "../../components/ListView/ListView";
import loaderContext from "../../context/loader/LoaderContext";
import { SupervisorColumns } from "../../constants/Columns/Supervisor";
import ListViewV2 from "../../components/ListViewV2/ListViewV2";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import PasswordResetModal from "../../components/PasswordResetModal/PasswordResetModal";
const queryClient = new QueryClient();

const FirmAdminUserList = (props) => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchParams] = useSearchParams();
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [selectedUsername, setSelectedUsername] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [fullName,setFullName]=useState("");
  const { setLoaderRunning, ref } = useContext(loaderContext);

  const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);

  const [dataQueryState, setDataQueryState] = useState({});

  let firmID =
    props.firmId === undefined
      ? searchParams.get("firmId") != null
        ? searchParams.get("firmId")
        : firmId
      : props.firmId;

  let initialSortOrder = {};

  AdminUserListColumn.forEach((column) => {
    if (column.sort) {
      // setSortOrder({...sortOrder, sortField: "default"})
      initialSortOrder[column.key] = true;
    }
  });

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }
   const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);
  };  
  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    console.log("--- FetchData ---", options);
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      firmId: firmID,
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    const response = await getAdminUserList(USERTYPES.FIRMADMIN, body);
    console.log("--- Response ---", response);
    let data = null;
    let pageCount = null;
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      data = response.data.data.userList;
      pageCount = response.data.data.totalPages;

      return {
        rows: data,
        pageCount: pageCount,
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      return {
        rows: data,
        pageCount: pageCount,
      };
    }
  };

  function handleCaching(data) {
    setUpdateCurrentPage(!updateCurrentPage);
    setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
  }

  const handleActionButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        if (event.target.innerText === "Activate") {
          event.target.innerText = t("button.deactivate");
        } else if (event.target.innerText === "Deactivate") {
          event.target.innerText = t("button.activate");
        }
        // handleCaching(data);
        ReloadData(data, true);
      }
    } catch (e) {
      // console.log(e);
    }
  };

  const handleLockButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserLockStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  function ReloadData(id, actionOrLocked) {
    // setUpdateCurrentPage(() => !updateCurrentPage);
    // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
     let newIndex = -1;
     let newData = dataQueryState?.data?.rows.filter((row, index) => {
       if (row.id == id) {
         newIndex = index;
         return true;
       }
       return false;
     });  
     setDataQueryState(() => {
       const newValue = {
         ...dataQueryState
       };
       if(newValue.data.rows[newIndex] != null){
          if(actionOrLocked){
            newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active;
          }else if(!actionOrLocked){
            newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
          }
       }
       return newValue;
     });
 
   }

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (props.firmId === undefined) {
      navigate(
        AuthRoutes.MYVIEWUSER + "?id=" + cell.id + "&firmId=" + cell.firm.id,
        {}
      );
    } else {
      navigate(
        AuthRoutes.MYVIEWUSER +
          "?id=" +
          cell.id +
          "&firmId=" +
          cell.firm.id +
          "&for=firm",
        {}
      );
    }
  };

  useEffect(() => {
    console.log();
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const columns = FirmAdminUserColumns(
    userId,
    handleActionButton,
    handleUserClick,
    handleLockButton,
    openPasswordReset
  );

  // const columns = SupervisorColumns(
  //   userId,
  //   handleActionButton,
  //   handleUserClick
  // );

  //const effectiveFirmId = props.firmId || searchParams.get("firmId");
  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <Link
          key="1"
          // to={
          //   props.firmId === undefined
          //     ? AuthRoutes.MYADDFIRMADMINUSER + "?firmId=" + firmId
          //     : AuthRoutes.MYADDFIRMADMINUSER +
          //       "?firmId=" +
          //       firmID +
          //       "&for=firm"
          // }
          to={
          AuthRoutes.MYADDFIRMADMINUSER +
          "?firmId=" +
          firmID +
          "&for=firm"
        }
        >
          <div className="add-button-list-view">
            {/* <AddButton text={t("admin.add-admin")} /> */}
            <PrimaryButton
              text={t("admin.add-firm-admin")}
              className={"common-default-active-button"}
            />
          </div>
        </Link>
      ),
    },
  ];

  const options = [
    { key: "username", text: t("user.username") },
    { key: "firstName", text: t("user.first-name") },
    { key: "lastName", text: t("user.last-name") },
    { key: "email", text: t("user.email") },
    { key: "mobile", text: t("user.mobile") },
    { key: "active", text: t("user.action") },
  ];

  
  const handleApplyClick = (filterValue) => {

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  return (
    <><PasswordResetModal
        username={selectedUsername}
        visible={showResetModal}
        onClose={() => setShowResetModal(false)}
        fullName={fullName}
      />
      {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
        // <ListView
        //   pageHeader="admin.admin"
        //   buttonsTopBar={buttonsTopBar}
        //   sortDropdownOptions={options}
        //   fetchDataFunction={fetchAdminUserList}
        //   columns={columns}
        //   handleUserClick={handleUserClick}
        //   widthContainer="40%"
        //   updateCurrentPage={updateCurrentPage}
        //   filterObj={filterObj}
        //   heightTBody="67vh"
        // />
        <ListViewV3
          buttonsTopBar={buttonsTopBar}
          sortDropdownOptions={options}
          fetchData={fetchData}
          columns={columns}
          handleUserClick={handleUserClick}
          filterObj={filterObj}
          setFilterObj={setFilterObj}
          sortObj={sortObj}
          setSortObj={setSortObj}
          setPagination={setPagination}
          paginationObj={paginationObj}
          uniqueKey={"Firmadmin"}
          heading={t("navbar.firm-admins")}
          handleApplyClick={handleApplyClick}
          placeholder={"Username"}
          showFilter={true}
          showSort={true}
          enhancedFilter={false}
          fullLength={props.fullLength}
          fullLengthForRow={props.fullLengthForRow}
          setDataQueryState={setDataQueryState}
          dataQueryState={dataQueryState}
        />
      )}
      {/* {(roles[0] != USERTYPES.FIRMADMIN && roles[0] != USERTYPES.ADMIN) && <NotAuthorized />} */}
    </>
  );
};

export default FirmAdminUserList;
